if ( typeof CollectionTabs !== 'function' ) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const tabs = this.querySelectorAll('.collection-tabs_tab');
      const panels = this.querySelectorAll('.collection-tabs_panel');
      const viewCollectionLink = this.querySelector('.section-heading__actions a');
      const viewCollectionLink2 = this.querySelector('.js-view-collection-link');

      tabs.forEach(tab => {

        tab.addEventListener('click', e => {

          e.preventDefault(); 

          tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true')
          });

          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          const targetPanelId = tab.querySelector('button').getAttribute('aria-controls');
          const collectionUrl = tab.querySelector('button').getAttribute('data-collection-url');
          
          if ( viewCollectionLink && collectionUrl ) {
            viewCollectionLink.setAttribute('href', collectionUrl);
          }
          if ( viewCollectionLink2 && collectionUrl ) {
            viewCollectionLink2.setAttribute('href', collectionUrl);
          }

          panels.forEach(panel => {
            if (panel.id === targetPanelId) {
              panel.classList.add('active');
              panel.removeAttribute('aria-hidden');
              const slider = panel.querySelector('css-slider');
              if ( slider ) {
                slider.resetSlider();
              }
            }
          });
        });
      });

      // Start with the contextually relevant collection when one is defined.
      const configuredTab = Number.parseInt(this.dataset.defaultTab || '0', 10);
      const initialTab = Number.isInteger(configuredTab) && configuredTab >= 0 && configuredTab < tabs.length ? configuredTab : 0;

      if (tabs.length > 0 && panels.length > 0) {
        tabs.forEach((tab, index) => {
          const isActive = index === initialTab;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }
    }

  }

  if ( typeof customElements.get('collection-tabs') == 'undefined' ) {
    customElements.define('collection-tabs', CollectionTabs);
	}

  window.addEventListener('load', () => {
    document.querySelectorAll('collection-tabs[data-default-tab]').forEach((element) => {
      const index = Number.parseInt(element.dataset.defaultTab || '0', 10);
      const tabs = element.querySelectorAll('.collection-tabs_tab');
      if (Number.isInteger(index) && index > 0 && tabs[index]) {
        tabs[index].click();
      }
    });
  });

  document.addEventListener('shopify:section:load', (e)=>{
    if ( e.target.classList.contains('mount-collection-tabs') ) {
      e.target.querySelector('collection-tabs')?.init();
    }
  });

}